require('../scss/_styles.scss');

(window as any).appComparisonInit = function appComparisonInit(moduleId: string){
  const wrapper = $(`.comparsion-${moduleId}`);
  const wrapperTable = wrapper.find('table');
  wrapperTable.addClass('comparsion-table');
  (wrapperTable as any).stackcolumns();

  const stackedTable = wrapper.find('.stacktable.small-only');
  stackedTable.addClass('comparsion-table-mobile').find('td[colspan]').next('td').remove();

  wrapper.on('click', 'a[href*="#"]', (e: any) => {
    e.preventDefault();
    const urlHash = $(e.currentTarget).attr('href').replace('#', '');
    $('.info-overlay').removeClass('open');
    $(`.info-${urlHash}`).addClass('open');
  })

  $('.close-info-overlay').click(() => {
    $('.info-overlay').removeClass('open');
  })

  wrapperTable.find('tr:last').addClass('last');
  wrapperTable.find('tr:last').prev().addClass('next-to-last');

  stackedTable.find('tr:last').addClass('last');
  stackedTable.find('tr:last').prev().addClass('next-to-last');
  stackedTable.find('.st-head-row').prev().addClass('last');
  stackedTable.find('.st-head-row').prev().prev().addClass('next-to-last');

  wrapper.find('.last a').addClass('btn btn-outline-dark');
}